<template>
	<div class="container mgs-stats-page pb-4">
		<h1>Shot Analysis</h1>
		<table class="table w-full">
			<thead>
				<tr class="mgs-stats-table-subhead">
					<th :colspan="roundYearRange.length + 3">Approach Play</th>
				</tr>
				<tr>
					<th></th>
					<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
						{{ year }}
					</th>
					<th>All</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="shotKey in shotAnalysis.shot_keys">
					<tr>
						<th>{{ shotKey }} Yd Chances</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.shots[year][shotKey].chances }}
						</th>
						<th>{{ shotAnalysis.all_shots[shotKey].chances }}</th>
					</tr>
					<tr>
						<th>{{ shotKey }} Yd Avg Shots to Hole Out</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.shots[year][shotKey].average_shots_to_finish }}
						</th>
						<th>{{ shotAnalysis.all_shots[shotKey].average_shots_to_finish }}</th>
					</tr>

					<tr>
						<th>{{ shotKey }} Yd Avg Dist to Hole (ft)</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.shots[year][shotKey].distance_to_hole_avg_feet }}
						</th>
						<th>{{ shotAnalysis.all_shots[shotKey].distance_to_hole_avg_feet }}</th>
					</tr>
					<tr>
						
						<th :colspan="roundYearRange.length + 3"></th>
					</tr>
				</template>
				<tr class="mgs-stats-table-subhead">
					<th :colspan="roundYearRange.length + 3">Putting</th>
				</tr>
				<tr>
					<th></th>
					<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
						{{ year }}
					</th>
					<th>All</th>
				</tr>
				<template v-for="puttKey in shotAnalysis.putt_keys">
					<tr>
						<th>{{ puttKey }} Feet Chances</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.putts[year][puttKey].chances }}
						</th>
						<th>{{ shotAnalysis.all_putts[puttKey].chances }}</th>
					</tr>
					<tr>
						<th>{{ puttKey }} Hole Outs</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.putts[year][puttKey].holed }}
						</th>
						<th>{{ shotAnalysis.all_putts[puttKey].holed }}</th>
					</tr>
					<tr>
						<th>{{ puttKey }} Holed Percentage</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.putts[year][puttKey].holed_percentage }}
						</th>
						<th>{{ shotAnalysis.all_putts[puttKey].holed_percentage }}</th>
					</tr>
					<tr>
						<th>{{ puttKey }} Feet Average Leave</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.putts[year][puttKey].average_leave }}
						</th>
						<th>{{ shotAnalysis.all_putts[puttKey].average_leave }}</th>
					</tr>

					<tr>
						<th>{{ puttKey }} Feet 3 Putt Or More Percentage</th>
						<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
							{{ shotAnalysis.putts[year][puttKey]['3_putts_or_more_percentage'] }}
						</th>
						<th>{{ shotAnalysis.all_putts[puttKey]['3_putts_or_more_percentage'] }}</th>
					</tr>
					<tr>
						
						<th :colspan="roundYearRange.length + 3"></th>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>
<script>
/** @format */

export default {
	name: "ShotAnalysis",
	props: {
		shotAnalysis: {
			type: Object,
			required: true
		}
	},
	components: {
		// "statistics-partials-plain": () =>
		// 	import(
		// 		/* webpackChunkName: "StatisticsPlain" */ "@/components/Statistics/Partials/Plain"
		// 	)
	},
	methods: {},
	computed: {
		roundYearRange() {
			return Object.keys(this.shotAnalysis.shots);
		}
	},
	mounted() {
		//this.setYearRange();
	},
	data() {
		return {};
	}
};
</script>
<style lang="scss">
/** @format */

.mgs-stats-page {
	.mgs-plain-statbox {
		@apply mb-1;
	}
}
.mgs-stats-table-subhead {
	background: $forestGreen;

	th {
		text-align: center !important;
		color: white;
		font-size: 1.5rem;
	}
}
</style>
